// Generated by scripts/version.py; do not edit.
export const BUILD_VERSION = "2.1.0-dev.177" as const
